import React, { Component} from 'react';
import { translate } from 'react-i18next';
import AutocompleteForm from '../../components/AutocompleteForm';
import InputForm from '../../components/InputForm';
import LabelForm from '../../components/LabelForm';
import SelectForm from '../../components/SelectForm';
import { lookupsLevel2 } from '../../libs/services';

var Config = require('../../config');

class AddressData extends Component{
	constructor(props) {
	    super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onAutocompleteSearch = this.onAutocompleteSearch.bind(this);
        this.onAutocompleteChange = this.onAutocompleteChange.bind(this);
        this.getData = this.getData.bind(this);
        this.setData = this.setData.bind(this);
        this.clearData = this.clearData.bind(this);

	    this.state = {
            street:"",
            no_ext:"",
            colonia:"",
            postal_code:"",

            load_mpio:false,
            mpio:"",
            municipios:[],
            state:"",
            states:[],
            
	      	mpioSelected:[],
	      	indice:-1,
            address_id:""
	    };
	}

	async componentDidMount() {
		this.props.onRef(this);

        var response = await lookupsLevel2('state_mx', 'parents');
        if(response){
            var options = response.map((res)=>{
                var obj = {
                    value: this.state.state === res.key ? res.key : res.key.toUpperCase(),
                    text:res.value_name
                }

                return obj;
            });

            this.setState({states: options});
        }
	}

    componentWillUnmount() {
	    this.props.onRef(null)
	}

    handleChange(e){
        if(e.target.name === 'postal_code'){
            if(e.target.value === ""){
				this.setState({[e.target.name]: e.target.value})
			}
            if(e.target.value.length < 6){
                let regex = new RegExp("^[0-9]+$");

                if(regex.test(e.target.value)){
                    this.setState({[e.target.name]: e.target.value})
                }
                
            }
        }else{
            this.setState({[e.target.name]: e.target.value});
        }
        
    }

    async onAutocompleteSearch(query){
        this.setState({load_mpio:true, indice:-1});

        var response = await lookupsLevel2(query.replace(/_/g, ' '), 'municipios');
        if(response){
            if(response.length > 0){
				for (var i = 0; i < response.length; i++) {
					response[i].values = response[i].municpio.value_name +', '+response[i].estado.value_name;
					response[i].id = i;
				};
				this.setState({	municipios: response });

			    //if (response.length > 1) {
			    	response.forEach((res, i)=>{
			    		if(this.state.state !== ""){
			    			if(res.estado.key.toUpperCase() === this.state.state.toUpperCase() &&
				    			(res.municpio.value_name.toUpperCase() === query.toUpperCase() ||
                                    res.municpio.key.toUpperCase() === query.toUpperCase())){
				    	
                                //this.setState({indice:i});
				    			this.onAutocompleteChange([res])
				    		}
			    		}else{         
                            if(res.municpio.value_name.toUpperCase() === query.toUpperCase() ||
                                res.municpio.key.toUpperCase() === query.toUpperCase()){
                                //this.setState({indice:i});
				    			this.onAutocompleteChange([res])
				    		}
                        }	
			    	});
			    		

			    /*}else {
			    	//this.setState({mpioSelected:response})
			    };*/

			}else{
				this.setState({mpio:'', state:''});
			}
        }

        this.setState({load_mpio:false});
    }

    onAutocompleteChange(values){
        
        if(values!== undefined){
			if(values.length>0){
                var index = this.state.municipios.findIndex(obj => obj.municpio.key === values[0].municpio.key);
                
                this.setState({
                    indice:index,
                    mpio:values[0].municpio.key,
				    state:values[0].estado.key
                });
			}
		}
    }

    getData(obj){
        obj = {...obj, address:{
            ...obj.address,
            street: this.state.street,
            ext_num: this.state.no_ext,
            colonia: this.state.colonia,
            municipio: this.state.mpio,
            estado:this.state.state,
            postal_code:this.state.postal_code
        }};

        return obj;
    }

    async setData(item){
        await this.setState({
            street:item.address.street,
            no_ext:item.address.ext_num !== null ? item.address.ext_num : '',
            address_id:item.address.id,
            colonia:item.address.colonia !== null ? item.address.colonia : '',
            postal_code:item.address.postal_code !== null ? item.address.postal_code : '',
            state:item.address.estado !== null ? item.address.estado : ''
        });

        if(item.address.municipio !== null){
            await this.onAutocompleteSearch(item.address.municipio);
        }
        
    }

    clearData(){
        this.setState({
            street:"",
            no_ext:"",
            address_id:"",
            colonia:"",
            postal_code:"",
            state:"",
            mpio:"",
            municipios:[],
            indice:-1
        });
    }

	render() {
		const { t } = this.props;
	    return (
	      	<div className="col-xs-12 no-padding">
				<div className="col-xs-12" style={{padding:"0px"}}>
                    {this.props.fields.map((field, i)=>
                        field.section_key === 'DONOR' ?
                            field.print ?
                                field.key === 'STREET' ?
                                    <div className="col-xs-12 col-sm-6" key={i}>
                                        <LabelForm text={t('content.generics.address.street')} />
                                        <InputForm 
                                            id="street"
                                            value={this.state.street}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            class="input_data_donor"
                                        />
                                    </div>
								: field.key === 'EXT_NUM' ?
									<div className="col-xs-12 col-sm-2" key={i}>
										<LabelForm text="No. Exterior" />
										<InputForm 
                                            id="no_ext"
                                            value={this.state.no_ext}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            class="input_data_donor"
                                            maxLength="4"
                                        />
									</div>
								: field.key === 'COLONIA' ?
									<div className="col-xs-12 col-sm-4" key={i}>
										<LabelForm text="Colonia" />
										<InputForm 
                                            id="colonia"
                                            value={this.state.colonia}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            class="input_data_donor"
                                            maxLength="50"
                                        />
									</div>
                                : null
                            : null
                        : null
                    )}
				</div>

				<div className="col-xs-12" style={{padding:"0px"}}>
                    {this.props.fields.map((field, i)=>
                        field.section_key === 'DONOR' ?
                            field.print ?
                                field.key === 'POSTAL_CODE' ?
                                    <div className="col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.generics.address.postal_code')} />
                                        <InputForm 
                                            id="postal_code"
                                            value={this.state.postal_code}
                                            disabled={this.props.blockFields}
                                            required={field.required}
                                            handleChange={this.handleChange}
                                            validate={this.props.validate}
                                            class="input_data_donor"
                                            maxLength="5"
                                        />
                                    </div>
                                : field.key === 'MUNICIPIO' ?
                                    <div className=" col-xs-12 col-sm-4" key={i}>
                                        <LabelForm text={t('content.generics.address.mpio')} />
                                        <AutocompleteForm 
                                            id="mpio"
                                            inputProps={{
                                                name:"MUNICIPIO",
                                                id:"MUNICIPIO",
                                                className:"input_data_donor",
                                                required:field.required
                                            }}
                                            options={this.state.municipios}
                                            minLength={3}
                                            disabled={this.props.blockFields}
                                            reference="_handleMunicipio"
                                            handleSearch={this.onAutocompleteSearch}
                                            handleChange={this.onAutocompleteChange}
                                            loading={this.state.load_mpio}
                                            selected={this.state.indice !== -1 ? [this.state.municipios[this.state.indice]] : []}
                                            onRef={ref => this.autocomplete_mpio = ref}
                                        />                                                                                
                                    </div>
                                : field.key === 'ESTADO' ?
                                    <div className=" col-xs-12 col-sm-4" key={i}>
                                        <div >
                                            <LabelForm text={t('content.generics.address.state')} />
                                            <SelectForm 
                                                id="state"
                                                value={this.state.state}
                                                disabled={true}
                                                required={field.required}
                                                options={this.state.states}
                                                handleChange={this.handleChange}
                                            />
                                        </div>
                                    </div>
                                : null
                            : null
                        : null
                    )}
				</div>
	      	</div>
	    );
	}
}

export default translate('translations')(AddressData);